<div class="header-buttons">
  <button class="square-btn btn-clear" (click)="onBackButtonClick()">
    <i class="material-icons chevron-icon">arrow_back</i>
  </button>
  <button class="square-btn btn-clear full-screen-button" (click)="onFullScreenClick()">
    <i class="material-icons chevron-icon">{{ isFullScreen ? 'fullscreen_exit' : 'fullscreen' }}</i>
  </button>
</div>
<span class="chatbot-name">{{ chatbotName }}</span>
<button class="btn btn-md button-primary" (click)="onNewChatClick()">
  <i class="material-icons chevron-icon">add</i><span>New chat</span>
</button>
